module.exports = __webpack_public_path__ + "static/media/D2.4b642ecf.jpg";